import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      La nova Fliko estas sufiĉe freŝkolora, kaj ŝi tute ne povas kompreni, kial oni penas kaŝi ŝin. 
      Ja ŝi tiel elstaras sur tiu trivita jako!
    </p>
    `
  )
}

const itemName = {
  esp: 'La fliko'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;